import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ToastConfigService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { UtilityService } from '../../core/services/utility/utility.service';
import { UserProfileService } from '../user-profile/user-profile.service';
// import { Route } from '@angular/router/src/config';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { APP_SETTINGS } from '@services';
import { NgIf, NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        NgStyle,
        RouterLink,
    ],
})
export class ResetPasswordComponent implements OnInit {

  public screenWidth: number;
  private subscription: ISubscription[];
  public errorMessage = '';
  public userId = '';
  public newPassword = '';
  public confirmPassword = '';
  public matchPwd = false;
  public passwordResetLink = '';

  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;
  bar4: string;
  public show = false;
  APP_SETTINGS: any;
  private colors = ['#F00', '#0F0', '#0F0'];

  private impermissible_prefixes = [
    'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec',
    'appl', 'ibm', 'pass', 'ros', 'asdf', 'sign', 'basic', 'log', 'sys', 'cadam',
    'test', 'tso', 'demo', 'net', 'valid', 'new', 'vtam', 'focus', 'xxx', 'game',
    '1234', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', 'bmw', 'mai', 'dez',
    'mae', 'okt', 'cad', 'catia', 'bm1ramf', 'beit08a', 'am07cu4', '19mond6'
  ];

  constructor(private toastService: ToastConfigService,
    private userProfileService: UserProfileService,
    private utilityService: UtilityService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.subscription = [];
    this.userId = this.route.snapshot.queryParamMap.get('userId');
    this.passwordResetLink = this.route.snapshot.queryParamMap.get('key');
  }
  private measureStrength(p) {
    let force = 0;
    const regex = /(\#|\$)/g;

    const lowerLetters = /[a-z]+/.test(p);
    const numbers = p.match(/[0-9]/g) ? p.match(/[0-9]/g).length < 5 : false;
    const symbols = regex.test(p);

    const flags = [lowerLetters, numbers, symbols];

    let passedMatches = 0;
    for (let flag of flags) {
      passedMatches += flag === true ? 1 : 0;
    }

    force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
    force += passedMatches * 10;

    // penality (short password)
    force = (p.length <= 7) ? Math.min(force, 10) : force;

    // penalty for impermissible prefixes
    force = this.impermissible_prefixes.find(prefix => p.substr(0, prefix.length).includes(prefix)) ? Math.min(force, 10) : force;

    // penality (poor variety of characters)
    force = (passedMatches <= 2) ? Math.min(force, 10) : force;

    return force;

  }
  private getColor(s) {
    let idx = 0;
    if (s <= 10) {
      idx = 0;
    } else {
      idx = 2;
    }
    return {
      idx: idx + 1,
      col: this.colors[idx]
    };
  }

  verifyPassword() {
    if (this.newPassword === this.confirmPassword) {
      this.matchPwd = true;
    } else {
      this.matchPwd = false;
    }
  }

  checkPasswordStrength() {
    const password = this.newPassword;
    this.setBarColors(3, '#DDD');
    if (password) {
      const c = this.getColor(this.measureStrength(password));
      this.setBarColors(c.idx, c.col);
      return c.idx;
    }
  }
  private setBarColors(count, col) {
    for (let _n = 0; _n < count; _n++) {
      this['bar' + _n] = col;
    }
  }
  sendResetLink() {
    this.errorMessage = '';
    const makeName = APP_SETTINGS.isBMW == 'true' ? 'BMW' : APP_SETTINGS.isRollsRoyce == 'true' ? 'ROLLSROYCE' : 'MINI';
    this.subscription.push(this.userProfileService.sendResetLinkToUser(this.userId, makeName).subscribe(data => {
      this.toastService.popToast(data['message']);
    },
      error => {
        this.errorMessage = error.error.message;
      }
    ));
  }
  resetPassword() {
    const userObj = {
      'userId': this.userId,
      'resetPassword': this.newPassword,
      'key': this.passwordResetLink
    };
    if (this.newPassword != this.confirmPassword) {
      return alert("Password and Confirm Password both are not matching.");
    }
    this.subscription.push(this.userProfileService.resetPassword(userObj).subscribe(data => {
      if (confirm(data['message'])) {
        this.router.navigateByUrl('/login');
      }

    },
      error => {
        this.errorMessage = error.error.message;
      }));
  }

}
